import { render } from "./ContingentRegistrationPage.vue?vue&type=template&id=6e9025e5&scoped=true"
import script from "./ContingentRegistrationPage.vue?vue&type=script&lang=js"
export * from "./ContingentRegistrationPage.vue?vue&type=script&lang=js"

import "./ContingentRegistrationPage.vue?vue&type=style&index=0&id=6e9025e5&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6e9025e5"]])

export default __exports__